import { Constants } from '@leverege/api-redux';
import { Comms } from '@leverege/comms';
import { GlobalState } from '@leverege/ui-redux';
import { toOpenApiPath } from "../util/OpenApiAnalyzerUtil.js";
export default ({
  apiName,
  api
}) => {
  const rootUrl = api.servers[0].url;
  const loginRoute = Object.entries(api.paths).find(([path, rte]) => {
    return rte['x-lev-is-login'];
  });
  const forgotPasswordRoute = Object.entries(api.paths).find(([path, rte]) => {
    return rte['x-lev-is-forgot-password'];
  });
  const resetPasswordRoute = Object.entries(api.paths).find(([path, rte]) => {
    return rte['x-lev-is-reset-password'];
  });
  const activateAccountRoute = Object.entries(api.paths).find(([path, rte]) => {
    return rte['x-lev-is-activate-account'];
  });
  const comms = new Comms({
    host: rootUrl
  });
  const options = api['x-lev-options'] || {};
  const plg = {
    id: `openApi.${apiName}`,
    options,
    name: apiName,
    model: api,
    rootUrl,
    basePath: options.basePath,
    token: null,
    getToken: () => {
      if (options.useOwnAuth) {
        return plg.token;
      }
      return GlobalState?.auth?.idToken;
    },
    comms,
    login: loginRoute ? (username, password) => {
      const credentials = {
        username,
        password
      };
      return comms.post(loginRoute[0].slice(1), credentials).then(result => {
        comms.setToken(result.token);
        if (localStorage) {
          localStorage.setItem(`${apiName}.id_token`, result.token);
          localStorage.setItem(`${apiName}.profile`, JSON.stringify(result));
        }
        return result;
      });
    } : null,
    logout: async () => {
      return null;
    },
    // TODO: make actually configurable
    activateAccount: activateAccountRoute ? data => {
      return comms.post(activateAccountRoute[0].slice(1), data);
    } : null,
    forgotPassword: forgotPasswordRoute ? username => {
      return comms.post(forgotPasswordRoute[0].slice(1), {
        username
      });
    } : null,
    resetPassword: resetPasswordRoute ? data => {
      return comms.post(resetPasswordRoute[0].slice(1), data);
    } : null,
    // this is necessary to make api-redux happy
    verify: async () => {
      throw new Error();
    },
    project: () => ({
      oidcClients: () => ({
        list: async () => ({
          items: []
        })
      }),
      twoFactorSettings: () => ({
        get: async () => null
      })
    }),
    // end silly compatibility things
    supports: (path, method) => {
      const openApiPath = toOpenApiPath(path, {
        options
      });
      return !!api.paths?.[openApiPath]?.[method];
    }
  };
  return plg;
};